/* eslint-disable no-unused-vars */
import Axios from "axios";
import Qs from "qs";
import store from "../store"; // 引入Vuex
import router from "../router/index"; // 引入router
import vue from "../main"; // 引入vue

Axios.defaults.timeout = 10000; // 请求超时时间 10s

// 环境切换
const domainArr = location.href.split("/");
Axios.defaults.baseURL =
  process.env.NODE_ENV === "development"
    ? "/apis/"
    : `${domainArr[0]}//${domainArr[2]}/`;
// request拦截器
Axios.interceptors.request.use(
  config => {
    // post请求
    if (config.method === "post") {
      config.data.token = store.state.user.token; // 为请求配置token
      // console.log('post')
    }
    // get请求
    if (config.method === "get") {
      // console.log('get')
    }
    // 若请求头为application/x-www-form-urlencoded，需要格式化数据
    if (
      config.headers["Content-Type"] === "application/x-www-form-urlencoded"
    ) {
      config.data = Qs.stringify(config.data); // 格式化数据
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// response拦截器
Axios.interceptors.response.use(
  response => {
    // console.log('data', response.data)
    // token过期判断
    if (response.data.code === 505) {
      vue.$message.error("token已过期，请重新登录");
      setTimeout(() => {
        router.push({ path: "/" });
      }, 2000);
    }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 封装get请求
 * @param {String} url 接口地址
 * @param {Object} params 参数
 * @param {Function} callback 回调函数
 * @param {Object} headers 请求头
 */
export function get (
  url,
  params = {},
  callback,
  headers = { "Content-Type": "application/x-www-form-urlencoded" }
) {
  Axios({
    url: url,
    method: "GET",
    params: params,
    headers: headers
  })
    .then(res => {
      callback(res.data);
    })
    .catch(error => {
      console.error(error);
    });
}

/**
 * 封装post请求
 * @param {String} url 接口地址
 * @param {Object} data 参数
 * @param {Function} callback 回调函数
 * @param {Object} headers 请求头
 */
export function post (
  url,
  data = {},
  callback,
  headers = { "Content-Type": "application/x-www-form-urlencoded" }
) {
  // 添加token
  data.token = store.state.user.token;
  Axios({
    url: url,
    method: "POST",
    data: data,
    headers: headers
  })
    .then(res => {
      callback(res.data);
    })
    .catch(error => {
      console.error(error);
    });
}
/**
 * post请求
 * 需要处理并发请求时用到
 * @param {String} url 接口地址
 * @param {Object} data 参数
 * @param {Object} headers 请求头
 */
export function postConcurrent (
  url,
  data = {},
  headers = { "Content-Type": "application/x-www-form-urlencoded" }
) {
  // 需要返回一个Promise对象才能处理并发
  return Axios({
    url: url,
    method: "POST",
    data: data,
    headers: headers
  });
}
/**
 * get请求
 * 处理并发请求
 * @param {String} url 接口请求地址
 * @param {Object} params 参数
 * @param {Object} headers 请求头
 */
export function getConcurrent (
  url,
  params = {},
  headers = { "Content-Type": "application/x-www-form-urlencoded" }
) {
  // 需要返回一个Promise对象才能处理并发
  return Axios({
    url: url,
    method: "GET",
    params: params,
    headers: headers
  });
}
/**
 *
 * 处理并发请求
 * @param {Array} funcArr promise数组
 * @param {Function} callback 回调函数
 */
export function concurrentRequest (funcArr, callback) {
  Axios.all(funcArr)
    // 所有请求执行完成
    .then(
      Axios.spread((...res) => {
        // console.log(a, b)
        callback(res);
      })
    )
    .catch(error => {
      console.error(error);
    });
}
/**
 * 文件上传
 * @param {String} url 接口请求地址
 * @param {Object} data 参数
 * @param {Function} callback 回调函数
 * @param {Object} headers 请求头
 */
export function postFile (
  url,
  data = {},
  callback,
  headers = { "Content-Type": "multipart/form-data" }
) {
  // console.log(data)
  const formData = new FormData();
  formData.append("file", data.file);
  // formData.append('token', store.state.token) // 带上token
  Axios({
    url: url,
    method: "POST",
    data: formData,
    headers: headers
  })
    .then(res => {
      callback(res.data);
    })
    .catch(error => {
      console.error(error);
    });
}
